import React from 'react';
import { AlertTriangle, AlertCircle, AlertOctagon } from 'lucide-react';

const SeverityBadge = ({ severity }) => {
  const getStyles = (severity) => {
    const baseStyles = "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-medium transition-colors";
    
    const severityStyles = {
      critical: {
        background: "bg-red-50 hover:bg-red-100",
        text: "text-red-700",
        border: "border border-red-200",
        icon: <AlertOctagon className="w-4 h-4 mr-1.5" />
      },
      high: {
        background: "bg-orange-50 hover:bg-orange-100",
        text: "text-orange-700",
        border: "border border-orange-200",
        icon: <AlertTriangle className="w-4 h-4 mr-1.5" />
      },
      medium: {
        background: "bg-yellow-50 hover:bg-yellow-100",
        text: "text-yellow-700",
        border: "border border-yellow-200",
        icon: <AlertCircle className="w-4 h-4 mr-1.5" />
      },
      low: {
        background: "bg-blue-50 hover:bg-blue-100",
        text: "text-blue-700",
        border: "border border-blue-200",
        icon: <AlertCircle className="w-4 h-4 mr-1.5" />
      }
    };

    const style = severityStyles[severity?.toLowerCase()] || severityStyles.low;
    return `${baseStyles} ${style.background} ${style.text} ${style.border}`;
  };

  const getIcon = (severity) => {
    const severityStyles = {
      critical: <AlertOctagon className="w-4 h-4 mr-1.5" />,
      high: <AlertTriangle className="w-4 h-4 mr-1.5" />,
      medium: <AlertCircle className="w-4 h-4 mr-1.5" />,
      low: <AlertCircle className="w-4 h-4 mr-1.5" />
    };

    return severityStyles[severity?.toLowerCase()] || severityStyles.low;
  };

  return (
    <span className={getStyles(severity)}>
      {getIcon(severity)}
      {severity}
    </span>
  );
};

export default SeverityBadge;